import {PATHS} from "../../routing";
import {LANDING_SECTIONS, scrollToSection} from "./sections";
import {CtaButton} from "./CtaButton";
import {Reveal} from "./Reveal";

interface HeaderProps {
    openLogin: () => void;
}

/**
 * Шапка лендинга: стеклянная полоса, на десктопе — плавающая «таблетка».
 *
 * APK-кнопки здесь больше нет (была иконкой рядом с «Войти»): скачивание живёт в
 * герое, финальном блоке и в подвале — на узком экране шапка из трёх кнопок
 * читалась хуже, чем один понятный вход.
 *
 * «Создать анкету» в шапке тоже убрана (Ирина, 27.08): дублировала «Начать
 * знакомство» из героя прямо под шапкой — два одинаковых по смыслу CTA рядом
 * читались как одна и та же кнопка дважды. «Войти» остаётся — это единственный
 * на лендинге вход для уже зарегистрированных.
 *
 * Появление — по загрузке и у полосы, а не у самого `<header>`: тег липкий
 * (`position: sticky`), и вешать на него движение — значит трогать то, за счёт
 * чего он держится у верхней кромки. Полоса внутри едет свободно.
 */
export function Header({openLogin}: HeaderProps) {
    return (
        <header className="rl-header">
            <Reveal className="rl-bar" trigger="mount" from="above">
                <a href={PATHS.landing} className="rl-brandmark">
                    <img src="/Brand/MatreshkaColor.png" alt="Матрёшка — логотип «Любить по-russки»"/>
                    <span className="rl-wm">Любить по-russки</span>
                </a>

                <nav className="rl-nav-links" aria-label="Разделы страницы">
                    {LANDING_SECTIONS.map((section) => (
                        <a
                            key={section.id}
                            href={`#${section.id}`}
                            onClick={(e) => {
                                // Лендинг живёт внутри ScrollArea (OverlayScrollbars), а не в
                                // окне: нативный переход по якорю в таком контейнере не
                                // прокручивает. href оставлен для средней кнопки и доступности.
                                e.preventDefault();
                                scrollToSection(section.id);
                            }}
                        >
                            {section.label}
                        </a>
                    ))}
                </nav>

                <div className="rl-header-actions">
                    <CtaButton className="rl-btn-brand rl-btn-sm" onClick={openLogin}>
                        Войти
                    </CtaButton>
                </div>
            </Reveal>
        </header>
    );
}
